import React, { useContext } from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import { mapBoxProps, BaseBoxProps } from '../_commons/BaseBox';
import { StyledProps } from '@front10';

export type BoxProps = StyledProps<BaseBoxProps & { type?: any }>;

function Box(props: BoxProps) {
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  const Tag = props?.type !== undefined ? props?.type : 'div';
  return <Tag {...mapBoxProps(props)} className={className} style={style}></Tag>;
}

Box.componentName = 'Box';

export default Box;
